import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import HubCard from '../components/HubCard';

const AWSCCPLearningHubPage: React.FC = () => {
  return (
    <Layout>
      <div className="page-hero">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 6%' }}>
          <div style={{ fontSize: '0.9rem', color: 'var(--gray-600)', marginBottom: '12px' }}>
            <Link to="/programs" style={{ color: 'var(--blue)' }}>Programs</Link> / AWS Cloud Practitioner
          </div>
          <h1>AWS Cloud Practitioner Learning Hub</h1>
          <p>Learn AWS from zero, prepare for the CLF-C02 certification, and test yourself. Pick the option that matches where you are today.</p>
          <div style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <span className="section-tag">Beginner friendly</span>
            <span className="section-tag">No technical background needed</span>
            <span className="section-tag orange">4-week path</span>
          </div>
        </div>
      </div>

      <div className="section" style={{ paddingTop: '44px', paddingBottom: '44px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 4%' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '22px', paddingBottom: '14px', borderBottom: '2px solid var(--blue-soft)' }}>
            <div style={{ width: '42px', height: '42px', borderRadius: '11px', background: 'var(--blue-pale)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem' }}>🧭</div>
            <div>
              <h2 style={{ fontSize: '1.35rem', fontWeight: 800, color: 'var(--gray-800)' }}>Choose your starting point</h2>
              <p style={{ fontSize: '0.8rem', color: 'var(--gray-400)' }}>You can move between the three at any time</p>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))', gap: '16px', marginBottom: '22px' }}>
            <HubCard
              tint="#EFF6FF" image="/images/hub/learn-new-bg.svg" title="1. New to AWS" tag="Start here if the cloud is new to you"
              desc="A trainer-led course in plain language. One story, a food-delivery app called QuickBite, grows from a single server into a secure, scalable system."
              items={['10 short lessons, 30 to 40 minutes each', 'Analogies, diagrams and common mix-ups', '"Pause and think" questions, no tools needed']}
              to="/aws-cloud-fundamentals-course" cta="Start the course" btn="btn-blue"
            />
            <HubCard
              tint="#FFF7ED" image="/images/hub/prepare-bg.svg" title="2. CLF-C02 Preparation" tag="Aiming for the AWS Cloud Practitioner certificate"
              desc="Your complete exam guide: a 4-week study plan, every exam domain explained in detail with diagrams, key notes and traps."
              items={['Preparation guide with service checklist', 'All four domains, task by task', 'Look-alike services, keyword shortcuts']}
              to="/aws-clf-c02-guide" cta="Open the preparation guide" btn="btn-orange"
            />
            <HubCard
              tint="#F0FDF4" image="/images/hub/practice-bg.svg" title="3. Practice" tag="Test what you know"
              desc="Practice questions grouped by topic, with instant right-or-wrong feedback and a short reason for each answer."
              items={['118 questions across 10 topics', 'Filter by topic to drill weak areas', 'Running score and reset']}
              to="/aws-clf-c02-practice" cta="Start practising" btn="btn-blue"
            />
          </div>

          <img src="/images/hub/path-ccp.svg" alt="Learn, prepare, practise, take the exam" style={{ display: 'block', width: '100%', maxWidth: '480px', height: 'auto', margin: '18px auto' }} />

          <div style={{ background: 'var(--orange-pale)', borderLeft: '4px solid var(--orange)', borderRadius: '12px', padding: '12px 18px', color: 'var(--gray-800)', fontSize: '.92rem' }}>
            <b style={{ color: 'var(--orange)' }}>Not sure where to start?</b> If you have never used AWS, begin with option 1. If you already know the basics and have an exam date, go to option 2 and follow the 4-week plan, then use option 3 every week to check your progress.
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AWSCCPLearningHubPage;
